import { CommonSliceType } from '../../../../types/slice';
import { toTextFromProp } from '../../fields/text';

export const dataNovaMapSlice = ({ primary }) => ({
  type: CommonSliceType.MAP,
  title: toTextFromProp('title', primary),
});
